import React, {useEffect, useState} from 'react';
import './style.scss';
import profileCardCoin from '../../../../../images/profile-card-coin.png';
import {CommonUtil} from "../../../../utils/CommonUtil";

export const GameItem = ({image, coins, reset, left, onClick}) => {
    const [clicked, setClicked] = useState(false);
    const [top, setTop] = useState(0);

    useEffect(() => {
        if (true === clicked) {
            onClick();
        }
    }, [clicked]);

    return <div
        draggable={false}
        className={'app-game-item' + (clicked > 0 ? ' app-game-item_clicked' : '') + ((clicked > 0 && reset)? ' app-game-item_danger' : '') + ((clicked > 0 && !reset)? ' app-game-item_success' : '')}
        style={{left: left + '%', top: top}}
        onClick={e => {
            if (false === CommonUtil().isTouchDevice()) {
                setTop(e.target.getBoundingClientRect().top);
                setClicked(true);
            }
        }}
        onTouchEnd={e => {
            if (true === CommonUtil().isTouchDevice()) {
                setTop(e.target.getBoundingClientRect().top);
                setClicked(true);
            }
        }}
    >
        {clicked && coins > 0 && <div className="app-game-item--coins">
            <span className="app-game-item--value">+{coins}</span>
            <img className="app-game-item--icon" src={profileCardCoin} alt={''}/>
        </div>}
        <img src={image} alt="" className="app-game-item--image"/>
    </div>
}
